const getItemName = (name) => {
  switch (name) {
    case "listing":
      return "Wynik wyszukiwania";
    case "leftpanel":
      return "Lewa kolumna";
    case "showitem":
      return "Strona produktu";
    case "mainpage":
      return "Pozostałe miejsca emisji";
    default:
      return name;
  }
};

const Placements = ({ data }) =>
  data?.map((name) => <p key={name}>{getItemName(name)}</p>);

export default Placements;
